'use client';

import { BreadcrumbList } from 'schema-dts';

export function getBreadcrumbStructuredData(
    pathname: string,
    breadcrumb: { label: string; href?: string }[],
): BreadcrumbList {
    return {
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumb.map(({ label, href }, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: label,
            item: {
                '@id': `https://www.bouyguestelecom.fr${href ?? pathname}`,
                '@type': 'Thing',
            },
        })),
    };
}
